export const CHECKIN_HOLD_LABELS = {
  pending_checkout: 'Pending Checkout',
  occupied: 'Occupied',
  reserved: 'Reserved',
  blocked: 'Blocked',
  web_checkin: 'Web check-in',
};

export const STAY_WINDOW_HOLD_REASONS = ['reserved', 'web_checkin'];

export function isStayWindowHoldReason(reason) {
  return STAY_WINDOW_HOLD_REASONS.includes(String(reason || '').trim().toLowerCase());
}

export function getCheckInRoomHoldReason(room) {
  if (!room) return '';
  const reason = String(room.unavailable_reason || '').trim().toLowerCase();
  if (reason && CHECKIN_HOLD_LABELS[reason]) return reason;
  if (room.pending_checkout === true || room.walk_in_pending_checkout === true) {
    return 'pending_checkout';
  }
  if (room.walk_in_overdue_checkout === true) return 'pending_checkout';
  if (room.walk_in_web_checkin === true || room.has_active_web_checkin === true) {
    return 'web_checkin';
  }
  if (room.is_maintenance_blocked === true || room.is_inventory_blocked === true) {
    return 'blocked';
  }
  if (room.is_available === false) {
    const status = String(room.status || '').trim().toLowerCase();
    if (status === 'occupied') return 'occupied';
    if (status === 'maintenance' || status === 'out_of_order') return 'blocked';
    return 'reserved';
  }
  return '';
}

export function getCheckInRoomHoldLabel(reason) {
  return CHECKIN_HOLD_LABELS[reason] || '';
}

export function getCheckInRoomHoldTooltip(reason, roomNumber, action = 'check-in') {
  const number = roomNumber ? `Room ${roomNumber}` : 'This room';
  if (reason === 'pending_checkout') {
    return `${number} is pending checkout. Complete checkout before assigning it.`;
  }
  if (reason === 'occupied') {
    return `${number} is occupied and cannot be used for ${action}.`;
  }
  if (reason === 'reserved') {
    return `${number} is reserved for another booking.`;
  }
  if (reason === 'web_checkin') {
    return `${number} has an active web check-in invite. Cancel the invite or wait until it expires before assigning it.`;
  }
  if (reason === 'blocked') {
    return `${number} is blocked or under maintenance.`;
  }
  return '';
}

export function getCheckInRoomHoldChipColor(reason) {
  if (reason === 'pending_checkout') return 'rgba(245, 124, 0, 0.94)';
  if (reason === 'web_checkin') return 'rgba(15, 118, 110, 0.94)';
  return 'rgba(211, 47, 47, 0.94)';
}

export function getCheckInRoomHoldOverlaySx(backgroundColor, isDark = false) {
  return {
    position: 'absolute',
    left: '50%',
    bottom: 8,
    transform: 'translateX(-50%)',
    zIndex: 2,
    maxWidth: 'calc(100% - 16px)',
    backgroundColor,
    color: '#fff',
    fontWeight: 700,
    fontSize: '0.7rem',
    height: 24,
    backdropFilter: 'blur(8px)',
    border: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.35)'}`,
    boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
    '& .MuiChip-label': {
      px: 1.25,
      whiteSpace: 'nowrap',
    },
  };
}
